import styled, { css } from 'styled-components';

interface AspectRatioProps {
    ratio?: string | number;
    maxWidth?: string | number;
}

const AspectRatio = styled.div<AspectRatioProps>`
    --aspect-ratio: ${({ ratio = 1 }) => ratio};
    --max-width: ${({ maxWidth = '100%' }) => (typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth)};

    display: block;
    position: relative;
    box-sizing: border-box;
    max-width: var(--max-width);

    &:before {
        display: block;
        content: '';
        width: 100%;
        aspect-ratio: var(--aspect-ratio);
        @supports not (aspect-ratio: 1/1) {
            height: 0;
            padding-bottom: calc(100% / (var(--aspect-ratio)));
        }
    }

    & > * {
        position: absolute;
        overflow: hidden;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }
`;

export const withAspectRatio = css<{ ratio: number }>`
    aspect-ratio: ${({ ratio }) => ratio};

    @supports not (aspect-ratio: 1/1) {
        height: 0;
        padding-bottom: calc(100% / ${({ ratio }) => ratio});
    }
`;

export default AspectRatio;
